import React from 'react';

import Card from '../../components/Card/Card';
import ErrorMessageNewFund from '../../components/ErrorMessages/ErrorMessageNewFund';
import ErrorMessageNoData from '../../components/ErrorMessages/ErrorMessageNoData';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';

import {
    BOND_MATURITY_DIVERSIFICATION,
    FI_ETF_BOND_MATURITY_DIVERSIFICATION
} from './queries';
import { bondMaturityUtil, bondMaturityUtilFI } from './util';
import { newFundUtil } from '../../utils/fund-info';
import { CARD_NAMES } from '../../utils/constants';

import styles from './BondMaturity.css';

const BondMaturity = ({ ticker, isFI }) => (
    <Card className="left">
        <GqlQueryWrapper
            query={
                isFI
                    ? FI_ETF_BOND_MATURITY_DIVERSIFICATION
                    : BOND_MATURITY_DIVERSIFICATION
            }
            variables={{ ticker }}
            dataFunc={isFI ? bondMaturityUtilFI : bondMaturityUtil}
            placeholder={() => <TablePreRender />}
        >
            {({ data: { data, inceptionDate, asOfDate } }) => (
                <React.Fragment>
                    {Boolean(data.length) && (
                        <React.Fragment>
                            <div className="subsection-no-border">
                                <TitleWithDescription title="Bond Maturity Diversification" />
                                <div className="subheaders">
                                    <div className="left">
                                        As a percentage of Total Net Assets*
                                    </div>
                                    <div className="date">As of {asOfDate}</div>
                                </div>
                                <div className="tables">
                                    <Table data={{ data }} />
                                </div>

                                <Table />
                            </div>
                            <div className="bond-maturity-footer-text">
                                * Total may not equal 100% due to rounding
                            </div>
                        </React.Fragment>
                    )}
                    {!data.length &&
                        (newFundUtil(inceptionDate) ? (
                            <ErrorMessageNewFund
                                cardName={CARD_NAMES.BOND_MATURITY}
                            />
                        ) : (
                            <ErrorMessageNoData
                                cardName={CARD_NAMES.BOND_MATURITY}
                            />
                        ))}{' '}
                </React.Fragment>
            )}
        </GqlQueryWrapper>

        <style jsx>{styles}</style>
    </Card>
);

export default BondMaturity;
